var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompareGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.636353 0.63623H33.3636V33.3635H0.636353V0.63623ZM2.89338 2.89328H15.3072V15.3071H2.89338V2.89328ZM31.1065 2.89328H18.6927V15.3071H31.1065V2.89328ZM18.6927 18.6927H31.1065V31.1065H18.6927V18.6927ZM15.3072 18.6927H2.89338V31.1065H15.3072V18.6927Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareGrid);
export default __webpack_public_path__ + "static/media/CompareGrid.455872dbebc45dce8d4648f42c193e0c.svg";
export { ForwardRef as ReactComponent };